import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import * as XLSX from "xlsx";
import "./Closecallreport.css";
import HeaderNavigation from "../../../../../Componants/Common/header Navigation/HeaderNavigation";
import DynamicTabs from "../../../../../components/DynamicTabs";
import { formatDate } from "../../../../../utils/dateFormatter";
import { Calendar } from "../../../../../Componants/Common/Calender";

const calltype = [];

const Closecallreport = () => {
  const [value, setValue] = useState({
    JobType: "",
    GSP: "",
    ServiceCentre: "",
    Organization: "",
  });

  const calltypeDefaultProps = {
    options: calltype,
    getOptionLabel: (option) => option.title,
  };

  const [selectedDate, setSelectedDate] = useState(null);

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const [excelData] = React.useState([
    // Your Excel data goes here
  ]);

  const downloadExcel = () => {
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Create a blob and initiate download
    const blob = XLSX.write(wb, {
      bookType: "xlsx",
      type: "blob",
      mimeType:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "your_file_name.xlsx";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <div className="container-Closecallreport">

      <HeaderNavigation value={'Close Call Report'}/>
      <DynamicTabs />

      <div className="textfiled-Closecallreport">
        <div className="line-Closecallreport">
          <div className="textinput-Closecallreport">
            <Autocomplete
              onChange={(e, val) => {
                setValue({ ...value, Transferfrom: val.title });
              }}
              {...calltypeDefaultProps}
              id="disable-close-on-select"
              disableCloseOnSelect
              renderInput={(params) => (
                <TextField {...params} label="Job Type:" variant="standard" />
              )}
            />
          </div>
          <div className="textinput-Closecallreport">
            <Autocomplete
              onChange={(e, val) => {
                setValue({ ...value, Transferfrom: val.title });
              }}
              {...calltypeDefaultProps}
              id="disable-close-on-select"
              disableCloseOnSelect
              renderInput={(params) => (
                <TextField {...params} label="GSP :" variant="standard" />
              )}
            />
          </div>
          <div className="textinput-Closecallreport">
            <Autocomplete
              onChange={(e, val) => {
                setValue({ ...value, Transferfrom: val.title });
              }}
              {...calltypeDefaultProps}
              id="disable-close-on-select"
              disableCloseOnSelect
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Service Centre:"
                  variant="standard"
                />
              )}
            />
          </div>
        </div>

        <div className="line-Closecallreport">
          <div className="textinput-Closecallreport">
           <Calendar handleChange={handleDateChange} fieldName="creationDate" label="Creation Date" />
          </div>
          <div className="textinput-Closecallreport">
            <Calendar handleChange={handleDateChange} fieldName="creationDate" label="Creation Date" />
          </div>
          <div className="textinput-Closecallreport">
            {" "}
            <Autocomplete
              onChange={(e, val) => {
                setValue({ ...value, TransferTo: val.title });
              }}
              {...calltypeDefaultProps}
              id="disable-close-on-select"
              disableCloseOnSelect
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Organization:"
                  variant="standard"
                />
              )}
            />
          </div>
        </div>

        <div className="excelbutton-Closecallreport">
          {" "}
          <button
            onClick={downloadExcel}
            style={{
              backgroundColor: "#32499F",
              color: "white",
              width: "10%",
              height: "5vh",
              whiteSpace: "nowrap",
            }}
          >
            Download Excel
          </button>
        </div>
      </div>
    </div>
  );
};

export default Closecallreport;
